import { ACTIVE_SUBSCRIPTION_PLANS } from 'types'

// Derive the list of plan options to render in the change-plan dropdown on a
// customer's detail page. The rule:
//
// - A customer who is already on one of the 2026 packages
//   (ACTIVE_SUBSCRIPTION_PLANS) can only be moved to another 2026 package.
//   Reverting back to a legacy plan would undo the migration.
// - A customer on a legacy plan can be moved to either another legacy plan or
//   to one of the 2026 packages. This lets admins migrate old customers into
//   the new packaging while still allowing lateral moves between legacy plans
//   if business requires it.
// - The current plan is always present in the returned options, even when the
//   API hasn't yet returned it. Without this, MUI Select renders blank when
//   the value doesn't match any MenuItem.
//
// `planNames` is the full list returned by `/customer/plans` (all rows from
// RisikaAPI's restriction_templates). It typically contains the six legacy
// plans plus the three 2026 packages.
export function derivePlanOptions(
  planNames: string[],
  currentPlan: string | undefined | null,
): string[] {
  const activePlans = ACTIVE_SUBSCRIPTION_PLANS as readonly string[]
  const isCurrentPlanActive =
    !!currentPlan && activePlans.includes(currentPlan)

  const baseOptions = isCurrentPlanActive
    ? planNames.filter((name) => activePlans.includes(name))
    : planNames

  if (currentPlan && !baseOptions.includes(currentPlan)) {
    return [currentPlan, ...baseOptions]
  }
  return baseOptions
}
